import { render, staticRenderFns } from "./SectionFour.vue?vue&type=template&id=09028f17&scoped=true&"
import script from "./SectionFour.vue?vue&type=script&lang=js&"
export * from "./SectionFour.vue?vue&type=script&lang=js&"
import style0 from "./SectionFour.vue?vue&type=style&index=0&id=09028f17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09028f17",
  null
  
)

export default component.exports